/**
 * 🎨 Pigment Design Tokens
 * Part of Pigment Design System
 * 
 * v1.0.0
 * Generated on Fri, 10 Feb 2023 17:23:26 GMT
 */

module.exports = {
  "color": {
    "primary": {
      "active": {
        "value": "#cd2214",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.red.active.value}"
        },
        "name": "ColorPrimaryActive",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "active"
        },
        "path": [
          "color",
          "primary",
          "active"
        ]
      },
      "hover": {
        "value": "#e13600",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.red.hover.value}"
        },
        "name": "ColorPrimaryHover",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "hover"
        },
        "path": [
          "color",
          "primary",
          "hover"
        ]
      },
      "default": {
        "value": "#fa3c00",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.red.default.value}"
        },
        "name": "ColorPrimaryDefault",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "default"
        },
        "path": [
          "color",
          "primary",
          "default"
        ]
      }
    },
    "secondary": {
      "active": {
        "value": "#000074",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.blue.active.value}"
        },
        "name": "ColorSecondaryActive",
        "attributes": {
          "category": "color",
          "type": "secondary",
          "item": "active"
        },
        "path": [
          "color",
          "secondary",
          "active"
        ]
      },
      "hover": {
        "value": "#061692",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.blue.hover.value}"
        },
        "name": "ColorSecondaryHover",
        "attributes": {
          "category": "color",
          "type": "secondary",
          "item": "hover"
        },
        "path": [
          "color",
          "secondary",
          "hover"
        ]
      },
      "default": {
        "value": "#1e39d2",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.blue.default.value}"
        },
        "name": "ColorSecondaryDefault",
        "attributes": {
          "category": "color",
          "type": "secondary",
          "item": "default"
        },
        "path": [
          "color",
          "secondary",
          "default"
        ]
      }
    },
    "tertiary": {
      "dark": {
        "value": "#560062",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.purple.dark.value}"
        },
        "name": "ColorTertiaryDark",
        "attributes": {
          "category": "color",
          "type": "tertiary",
          "item": "dark"
        },
        "path": [
          "color",
          "tertiary",
          "dark"
        ]
      },
      "medium": {
        "value": "#792a82",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.purple.medium.value}"
        },
        "name": "ColorTertiaryMedium",
        "attributes": {
          "category": "color",
          "type": "tertiary",
          "item": "medium"
        },
        "path": [
          "color",
          "tertiary",
          "medium"
        ]
      },
      "default": {
        "value": "#a639b2",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.purple.default.value}"
        },
        "name": "ColorTertiaryDefault",
        "attributes": {
          "category": "color",
          "type": "tertiary",
          "item": "default"
        },
        "path": [
          "color",
          "tertiary",
          "default"
        ]
      },
      "light": {
        "value": "#be6fc7",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "{color.purple.light.value}"
        },
        "name": "ColorTertiaryLight",
        "attributes": {
          "category": "color",
          "type": "tertiary",
          "item": "light"
        },
        "path": [
          "color",
          "tertiary",
          "light"
        ]
      }
    },
    "status": {
      "success": {
        "value": "#198038",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "#198038"
        },
        "name": "ColorStatusSuccess",
        "attributes": {
          "category": "color",
          "type": "status",
          "item": "success"
        },
        "path": [
          "color",
          "status",
          "success"
        ]
      },
      "error": {
        "value": "#da1e28",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "#DA1E28"
        },
        "name": "ColorStatusError",
        "attributes": {
          "category": "color",
          "type": "status",
          "item": "error"
        },
        "path": [
          "color",
          "status",
          "error"
        ]
      },
      "warning": {
        "value": "#f1c21b",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "#F1C21B"
        },
        "name": "ColorStatusWarning",
        "attributes": {
          "category": "color",
          "type": "status",
          "item": "warning"
        },
        "path": [
          "color",
          "status",
          "warning"
        ]
      },
      "info": {
        "value": "#0043ce",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "#0043CE"
        },
        "name": "ColorStatusInfo",
        "attributes": {
          "category": "color",
          "type": "status",
          "item": "info"
        },
        "path": [
          "color",
          "status",
          "info"
        ]
      }
    },
    "shade": {
      "black": {
        "value": "#000000",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "#000000"
        },
        "name": "ColorShadeBlack",
        "attributes": {
          "category": "color",
          "type": "shade",
          "item": "black"
        },
        "path": [
          "color",
          "shade",
          "black"
        ]
      },
      "white": {
        "value": "#ffffff",
        "filePath": "src/color/base.js",
        "isSource": true,
        "original": {
          "value": "#FFFFFF"
        },
        "name": "ColorShadeWhite",
        "attributes": {
          "category": "color",
          "type": "shade",
          "item": "white"
        },
        "path": [
          "color",
          "shade",
          "white"
        ]
      }
    },
    "red": {
      "active": {
        "value": "#cd2214",
        "comment": "Inky Red / Active",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#CD2214",
          "comment": "Inky Red / Active"
        },
        "name": "ColorRedActive",
        "attributes": {
          "category": "color",
          "type": "red",
          "item": "active"
        },
        "path": [
          "color",
          "red",
          "active"
        ]
      },
      "hover": {
        "value": "#e13600",
        "comment": "Inky Red / Hover",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#E13600",
          "comment": "Inky Red / Hover"
        },
        "name": "ColorRedHover",
        "attributes": {
          "category": "color",
          "type": "red",
          "item": "hover"
        },
        "path": [
          "color",
          "red",
          "hover"
        ]
      },
      "default": {
        "value": "#fa3c00",
        "comment": "Inky Red / Default",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#FA3C00",
          "comment": "Inky Red / Default"
        },
        "name": "ColorRedDefault",
        "attributes": {
          "category": "color",
          "type": "red",
          "item": "default"
        },
        "path": [
          "color",
          "red",
          "default"
        ]
      }
    },
    "blue": {
      "active": {
        "value": "#000074",
        "comment": "Community Blue / Active",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#000074",
          "comment": "Community Blue / Active"
        },
        "name": "ColorBlueActive",
        "attributes": {
          "category": "color",
          "type": "blue",
          "item": "active"
        },
        "path": [
          "color",
          "blue",
          "active"
        ]
      },
      "hover": {
        "value": "#061692",
        "comment": "Community Blue / Hover",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#061692",
          "comment": "Community Blue / Hover"
        },
        "name": "ColorBlueHover",
        "attributes": {
          "category": "color",
          "type": "blue",
          "item": "hover"
        },
        "path": [
          "color",
          "blue",
          "hover"
        ]
      },
      "default": {
        "value": "#1e39d2",
        "comment": "Community Blue / Default",
        "alpha": {
          "active": {
            "value": "rgba(30, 57, 210, 0.1)",
            "comment": "Community Blue 10% opacity",
            "filePath": "src/color/palette.js",
            "isSource": true
          },
          "hover": {
            "value": "rgba(30, 57, 210, 0.05)",
            "comment": "Community Blue 5% opacity",
            "filePath": "src/color/palette.js",
            "isSource": true
          }
        },
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#1E39D2",
          "comment": "Community Blue / Default",
          "alpha": {
            "active": {
              "value": "rgba(30, 57, 210, 0.1)",
              "comment": "Community Blue 10% opacity",
              "filePath": "src/color/palette.js",
              "isSource": true
            },
            "hover": {
              "value": "rgba(30, 57, 210, 0.05)",
              "comment": "Community Blue 5% opacity",
              "filePath": "src/color/palette.js",
              "isSource": true
            }
          }
        },
        "name": "ColorBlueDefault",
        "attributes": {
          "category": "color",
          "type": "blue",
          "item": "default"
        },
        "path": [
          "color",
          "blue",
          "default"
        ]
      }
    },
    "purple": {
      "dark": {
        "value": "#560062",
        "comment": "Passion Purple / Dark",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#560062",
          "comment": "Passion Purple / Dark"
        },
        "name": "ColorPurpleDark",
        "attributes": {
          "category": "color",
          "type": "purple",
          "item": "dark"
        },
        "path": [
          "color",
          "purple",
          "dark"
        ]
      },
      "medium": {
        "value": "#792a82",
        "comment": "Passion Purple / Medium",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#792A82",
          "comment": "Passion Purple / Medium"
        },
        "name": "ColorPurpleMedium",
        "attributes": {
          "category": "color",
          "type": "purple",
          "item": "medium"
        },
        "path": [
          "color",
          "purple",
          "medium"
        ]
      },
      "default": {
        "value": "#a639b2",
        "comment": "Passion Purple / Default",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#A639B2",
          "comment": "Passion Purple / Default"
        },
        "name": "ColorPurpleDefault",
        "attributes": {
          "category": "color",
          "type": "purple",
          "item": "default"
        },
        "path": [
          "color",
          "purple",
          "default"
        ]
      },
      "light": {
        "value": "#be6fc7",
        "comment": "Passion Purple / Light",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#BE6FC7",
          "comment": "Passion Purple / Light"
        },
        "name": "ColorPurpleLight",
        "attributes": {
          "category": "color",
          "type": "purple",
          "item": "light"
        },
        "path": [
          "color",
          "purple",
          "light"
        ]
      }
    },
    "teal": {
      "dark": {
        "value": "#209386",
        "comment": "Tee-l / Dark",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#209386",
          "comment": "Tee-l / Dark"
        },
        "name": "ColorTealDark",
        "attributes": {
          "category": "color",
          "type": "teal",
          "item": "dark"
        },
        "path": [
          "color",
          "teal",
          "dark"
        ]
      },
      "medium": {
        "value": "#48bbae",
        "comment": "Tee-l / Medium",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#48BBAE",
          "comment": "Tee-l / Medium"
        },
        "name": "ColorTealMedium",
        "attributes": {
          "category": "color",
          "type": "teal",
          "item": "medium"
        },
        "path": [
          "color",
          "teal",
          "medium"
        ]
      },
      "default": {
        "value": "#5ccfc2",
        "comment": "Tee-l / Default",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#5CCFC2",
          "comment": "Tee-l / Default"
        },
        "name": "ColorTealDefault",
        "attributes": {
          "category": "color",
          "type": "teal",
          "item": "default"
        },
        "path": [
          "color",
          "teal",
          "default"
        ]
      },
      "light": {
        "value": "#97f7ec",
        "comment": "Tee-l / Light",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#97F7EC",
          "comment": "Tee-l / Light"
        },
        "name": "ColorTealLight",
        "attributes": {
          "category": "color",
          "type": "teal",
          "item": "light"
        },
        "path": [
          "color",
          "teal",
          "light"
        ]
      }
    },
    "yellow": {
      "dark": {
        "value": "#cdaa00",
        "comment": "Yellow / Dark",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#CDAA00",
          "comment": "Yellow / Dark"
        },
        "name": "ColorYellowDark",
        "attributes": {
          "category": "color",
          "type": "yellow",
          "item": "dark"
        },
        "path": [
          "color",
          "yellow",
          "dark"
        ]
      },
      "medium": {
        "value": "#ebc80a",
        "comment": "Yellow / Medium",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#EBC80A",
          "comment": "Yellow / Medium"
        },
        "name": "ColorYellowMedium",
        "attributes": {
          "category": "color",
          "type": "yellow",
          "item": "medium"
        },
        "path": [
          "color",
          "yellow",
          "medium"
        ]
      },
      "default": {
        "value": "#ffdc1e",
        "comment": "Yellow / Default",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#FFDC1E",
          "comment": "Yellow / Default"
        },
        "name": "ColorYellowDefault",
        "attributes": {
          "category": "color",
          "type": "yellow",
          "item": "default"
        },
        "path": [
          "color",
          "yellow",
          "default"
        ]
      },
      "light": {
        "value": "#fdfa83",
        "comment": "Yellow / Light",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#FDFA83",
          "comment": "Yellow / Light"
        },
        "name": "ColorYellowLight",
        "attributes": {
          "category": "color",
          "type": "yellow",
          "item": "light"
        },
        "path": [
          "color",
          "yellow",
          "light"
        ]
      }
    },
    "gray": {
      "hover": {
        "value": "#181818",
        "comment": "Obsidian 5% opacity",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "rgba(24, 24, 24, 0.05)",
          "comment": "Obsidian 5% opacity"
        },
        "name": "ColorGrayHover",
        "attributes": {
          "category": "color",
          "type": "gray",
          "item": "hover"
        },
        "path": [
          "color",
          "gray",
          "hover"
        ]
      },
      "active": {
        "value": "#181818",
        "comment": "Obsidian 10% opacity",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "rgba(24, 24, 24, 0.1)",
          "comment": "Obsidian 10% opacity"
        },
        "name": "ColorGrayActive",
        "attributes": {
          "category": "color",
          "type": "gray",
          "item": "active"
        },
        "path": [
          "color",
          "gray",
          "active"
        ]
      },
      "obsidian": {
        "value": "#181818",
        "comment": "Obsidian",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#181818",
          "comment": "Obsidian"
        },
        "name": "ColorGrayObsidian",
        "attributes": {
          "category": "color",
          "type": "gray",
          "item": "obsidian"
        },
        "path": [
          "color",
          "gray",
          "obsidian"
        ]
      },
      "slateDark": {
        "value": "#2c2c2c",
        "comment": "Slate Dark",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#2C2C2C",
          "comment": "Slate Dark"
        },
        "name": "ColorGraySlateDark",
        "attributes": {
          "category": "color",
          "type": "gray",
          "item": "slateDark"
        },
        "path": [
          "color",
          "gray",
          "slateDark"
        ]
      },
      "slateDefault": {
        "value": "#4a4a4a",
        "comment": "Slate Default",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#4A4A4A",
          "comment": "Slate Default"
        },
        "name": "ColorGraySlateDefault",
        "attributes": {
          "category": "color",
          "type": "gray",
          "item": "slateDefault"
        },
        "path": [
          "color",
          "gray",
          "slateDefault"
        ]
      },
      "limestone": {
        "value": "#939393",
        "comment": "Limestone",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#939393",
          "comment": "Limestone"
        },
        "name": "ColorGrayLimestone",
        "attributes": {
          "category": "color",
          "type": "gray",
          "item": "limestone"
        },
        "path": [
          "color",
          "gray",
          "limestone"
        ]
      },
      "disabled": {
        "value": "#c6c6c6",
        "comment": "Disabled",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#C6C6C6",
          "comment": "Disabled"
        },
        "name": "ColorGrayDisabled",
        "attributes": {
          "category": "color",
          "type": "gray",
          "item": "disabled"
        },
        "path": [
          "color",
          "gray",
          "disabled"
        ]
      },
      "accent": {
        "value": "#e3e3e3",
        "comment": "Accent",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#E3E3E3",
          "comment": "Accent"
        },
        "name": "ColorGrayAccent",
        "attributes": {
          "category": "color",
          "type": "gray",
          "item": "accent"
        },
        "path": [
          "color",
          "gray",
          "accent"
        ]
      },
      "light": {
        "value": "#f4f4f4",
        "comment": "Light",
        "filePath": "src/color/palette.js",
        "isSource": true,
        "original": {
          "value": "#F4F4F4",
          "comment": "Light"
        },
        "name": "ColorGrayLight",
        "attributes": {
          "category": "color",
          "type": "gray",
          "item": "light"
        },
        "path": [
          "color",
          "gray",
          "light"
        ]
      }
    },
    "background": {
      "card": {
        "value": "#ffffff",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#ffffff",
          "type": "color"
        },
        "name": "ColorBackgroundCard",
        "attributes": {
          "category": "color",
          "type": "background",
          "item": "card"
        },
        "path": [
          "color",
          "background",
          "card"
        ]
      },
      "menu": {
        "value": "#ffffff",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#ffffff",
          "type": "color"
        },
        "name": "ColorBackgroundMenu",
        "attributes": {
          "category": "color",
          "type": "background",
          "item": "menu"
        },
        "path": [
          "color",
          "background",
          "menu"
        ]
      },
      "page": {
        "value": "#f5f5f5",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#f5f5f5",
          "type": "color"
        },
        "name": "ColorBackgroundPage",
        "attributes": {
          "category": "color",
          "type": "background",
          "item": "page"
        },
        "path": [
          "color",
          "background",
          "page"
        ]
      },
      "productImage": {
        "value": "#e3e3e3",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#e3e3e3",
          "type": "color"
        },
        "name": "ColorBackgroundProductImage",
        "attributes": {
          "category": "color",
          "type": "background",
          "item": "productImage"
        },
        "path": [
          "color",
          "background",
          "productImage"
        ]
      },
      "skrim": {
        "value": "#000000",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#00000069",
          "type": "color"
        },
        "name": "ColorBackgroundSkrim",
        "attributes": {
          "category": "color",
          "type": "background",
          "item": "skrim"
        },
        "path": [
          "color",
          "background",
          "skrim"
        ]
      },
      "section": {
        "value": "#000000",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#0000000a",
          "type": "color"
        },
        "name": "ColorBackgroundSection",
        "attributes": {
          "category": "color",
          "type": "background",
          "item": "section"
        },
        "path": [
          "color",
          "background",
          "section"
        ]
      }
    },
    "text": {
      "primary": {
        "value": "#000000",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#000000db",
          "type": "color"
        },
        "name": "ColorTextPrimary",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "primary"
        },
        "path": [
          "color",
          "text",
          "primary"
        ]
      },
      "secondary": {
        "value": "#000000",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#00000091",
          "type": "color"
        },
        "name": "ColorTextSecondary",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "secondary"
        },
        "path": [
          "color",
          "text",
          "secondary"
        ]
      },
      "disabled": {
        "value": "#000000",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#00000069",
          "type": "color"
        },
        "name": "ColorTextDisabled",
        "attributes": {
          "category": "color",
          "type": "text",
          "item": "disabled"
        },
        "path": [
          "color",
          "text",
          "disabled"
        ]
      }
    },
    "border": {
      "divider": {
        "value": "#000000",
        "type": "color",
        "filePath": "src/tokenTransformerOutput.tmp.json",
        "isSource": true,
        "original": {
          "value": "#0000001c",
          "type": "color"
        },
        "name": "ColorBorderDivider",
        "attributes": {
          "category": "color",
          "type": "border",
          "item": "divider"
        },
        "path": [
          "color",
          "border",
          "divider"
        ]
      }
    },
    "neutral": {
      "surface": {
        "paper": {
          "value": "#ffffff",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#ffffff",
            "type": "color"
          },
          "name": "ColorNeutralSurfacePaper",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "surface",
            "subitem": "paper"
          },
          "path": [
            "color",
            "neutral",
            "surface",
            "paper"
          ]
        },
        "pageBG": {
          "value": "#f5f5f5",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#f5f5f5",
            "type": "color"
          },
          "name": "ColorNeutralSurfacePageBg",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "surface",
            "subitem": "pageBG"
          },
          "path": [
            "color",
            "neutral",
            "surface",
            "pageBG"
          ]
        },
        "imageBG": {
          "value": "#e3e3e3",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#e3e3e3",
            "type": "color"
          },
          "name": "ColorNeutralSurfaceImageBg",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "surface",
            "subitem": "imageBG"
          },
          "path": [
            "color",
            "neutral",
            "surface",
            "imageBG"
          ]
        },
        "strong": {
          "value": "#363636",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#363636",
            "type": "color"
          },
          "name": "ColorNeutralSurfaceStrong",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "surface",
            "subitem": "strong"
          },
          "path": [
            "color",
            "neutral",
            "surface",
            "strong"
          ]
        }
      },
      "shade": {
        "weak": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0000000a",
            "type": "color"
          },
          "name": "ColorNeutralShadeWeak",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "shade",
            "subitem": "weak"
          },
          "path": [
            "color",
            "neutral",
            "shade",
            "weak"
          ]
        },
        "medium": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0000001c",
            "type": "color"
          },
          "name": "ColorNeutralShadeMedium",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "shade",
            "subitem": "medium"
          },
          "path": [
            "color",
            "neutral",
            "shade",
            "medium"
          ]
        },
        "strong": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0000002e",
            "type": "color"
          },
          "name": "ColorNeutralShadeStrong",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "shade",
            "subitem": "strong"
          },
          "path": [
            "color",
            "neutral",
            "shade",
            "strong"
          ]
        },
        "cover": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000069",
            "type": "color"
          },
          "name": "ColorNeutralShadeCover",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "shade",
            "subitem": "cover"
          },
          "path": [
            "color",
            "neutral",
            "shade",
            "cover"
          ]
        }
      },
      "text": {
        "strong": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#000000db",
            "type": "color"
          },
          "name": "ColorNeutralTextStrong",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "text",
            "subitem": "strong"
          },
          "path": [
            "color",
            "neutral",
            "text",
            "strong"
          ]
        },
        "medium": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000091",
            "type": "color"
          },
          "name": "ColorNeutralTextMedium",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "text",
            "subitem": "medium"
          },
          "path": [
            "color",
            "neutral",
            "text",
            "medium"
          ]
        },
        "weak": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000069",
            "type": "color"
          },
          "name": "ColorNeutralTextWeak",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "text",
            "subitem": "weak"
          },
          "path": [
            "color",
            "neutral",
            "text",
            "weak"
          ]
        },
        "weaker": {
          "value": "#000000",
          "type": "color",
          "description": "this token color does not meet contrast standards for text, it should only be used sparingly when text is non-essential but needs to differentiate from other text on screen, such as placeholder text in a field that you don't want to confuse with an already-filled field.",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000047",
            "type": "color",
            "description": "this token color does not meet contrast standards for text, it should only be used sparingly when text is non-essential but needs to differentiate from other text on screen, such as placeholder text in a field that you don't want to confuse with an already-filled field."
          },
          "name": "ColorNeutralTextWeaker",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "text",
            "subitem": "weaker"
          },
          "path": [
            "color",
            "neutral",
            "text",
            "weaker"
          ]
        },
        "onFill": {
          "value": "#ffffff",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#ffffff",
            "type": "color"
          },
          "name": "ColorNeutralTextOnFill",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "text",
            "subitem": "onFill"
          },
          "path": [
            "color",
            "neutral",
            "text",
            "onFill"
          ]
        }
      },
      "icon": {
        "default": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000091",
            "type": "color"
          },
          "name": "ColorNeutralIconDefault",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "icon",
            "subitem": "default"
          },
          "path": [
            "color",
            "neutral",
            "icon",
            "default"
          ]
        },
        "strong": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#000000db",
            "type": "color"
          },
          "name": "ColorNeutralIconStrong",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "icon",
            "subitem": "strong"
          },
          "path": [
            "color",
            "neutral",
            "icon",
            "strong"
          ]
        },
        "weak": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000047",
            "type": "color"
          },
          "name": "ColorNeutralIconWeak",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "icon",
            "subitem": "weak"
          },
          "path": [
            "color",
            "neutral",
            "icon",
            "weak"
          ]
        },
        "onFill": {
          "value": "#ffffff",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#ffffff",
            "type": "color"
          },
          "name": "ColorNeutralIconOnFill",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "icon",
            "subitem": "onFill"
          },
          "path": [
            "color",
            "neutral",
            "icon",
            "onFill"
          ]
        }
      },
      "border": {
        "default": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0000001c",
            "type": "color"
          },
          "name": "ColorNeutralBorderDefault",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "border",
            "subitem": "default"
          },
          "path": [
            "color",
            "neutral",
            "border",
            "default"
          ]
        },
        "strong": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000069",
            "type": "color"
          },
          "name": "ColorNeutralBorderStrong",
          "attributes": {
            "category": "color",
            "type": "neutral",
            "item": "border",
            "subitem": "strong"
          },
          "path": [
            "color",
            "neutral",
            "border",
            "strong"
          ]
        }
      }
    },
    "interactive": {
      "bold": {
        "default": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#000000db",
            "type": "color"
          },
          "name": "ColorInteractiveBoldDefault",
          "attributes": {
            "category": "color",
            "type": "interactive",
            "item": "bold",
            "subitem": "default"
          },
          "path": [
            "color",
            "interactive",
            "bold",
            "default"
          ]
        },
        "hover": {
          "value": "#182ea8",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#182ea8",
            "type": "color"
          },
          "name": "ColorInteractiveBoldHover",
          "attributes": {
            "category": "color",
            "type": "interactive",
            "item": "bold",
            "subitem": "hover"
          },
          "path": [
            "color",
            "interactive",
            "bold",
            "hover"
          ]
        },
        "pressed": {
          "value": "#132486",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#132486",
            "type": "color"
          },
          "name": "ColorInteractiveBoldPressed",
          "attributes": {
            "category": "color",
            "type": "interactive",
            "item": "bold",
            "subitem": "pressed"
          },
          "path": [
            "color",
            "interactive",
            "bold",
            "pressed"
          ]
        },
        "disabled": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000047",
            "type": "color"
          },
          "name": "ColorInteractiveBoldDisabled",
          "attributes": {
            "category": "color",
            "type": "interactive",
            "item": "bold",
            "subitem": "disabled"
          },
          "path": [
            "color",
            "interactive",
            "bold",
            "disabled"
          ]
        },
        "accessible": {
          "value": "#000000",
          "type": "color",
          "description": "Closest shade of default color that exceeds a 4.5:1 contrast ratio against the page color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#000000db",
            "type": "color",
            "description": "Closest shade of default color that exceeds a 4.5:1 contrast ratio against the page color"
          },
          "name": "ColorInteractiveBoldAccessible",
          "attributes": {
            "category": "color",
            "type": "interactive",
            "item": "bold",
            "subitem": "accessible"
          },
          "path": [
            "color",
            "interactive",
            "bold",
            "accessible"
          ]
        }
      },
      "subtle": {
        "default": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0000000a",
            "type": "color"
          },
          "name": "ColorInteractiveSubtleDefault",
          "attributes": {
            "category": "color",
            "type": "interactive",
            "item": "subtle",
            "subitem": "default"
          },
          "path": [
            "color",
            "interactive",
            "subtle",
            "default"
          ]
        },
        "hover": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0000001c",
            "type": "color"
          },
          "name": "ColorInteractiveSubtleHover",
          "attributes": {
            "category": "color",
            "type": "interactive",
            "item": "subtle",
            "subitem": "hover"
          },
          "path": [
            "color",
            "interactive",
            "subtle",
            "hover"
          ]
        },
        "pressed": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0000002e",
            "type": "color"
          },
          "name": "ColorInteractiveSubtlePressed",
          "attributes": {
            "category": "color",
            "type": "interactive",
            "item": "subtle",
            "subitem": "pressed"
          },
          "path": [
            "color",
            "interactive",
            "subtle",
            "pressed"
          ]
        }
      }
    },
    "momentum": {
      "bold": {
        "default": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d2",
            "type": "color"
          },
          "name": "ColorMomentumBoldDefault",
          "attributes": {
            "category": "color",
            "type": "momentum",
            "item": "bold",
            "subitem": "default"
          },
          "path": [
            "color",
            "momentum",
            "bold",
            "default"
          ]
        },
        "hover": {
          "value": "#182ea8",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#182ea8",
            "type": "color"
          },
          "name": "ColorMomentumBoldHover",
          "attributes": {
            "category": "color",
            "type": "momentum",
            "item": "bold",
            "subitem": "hover"
          },
          "path": [
            "color",
            "momentum",
            "bold",
            "hover"
          ]
        },
        "pressed": {
          "value": "#132486",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#132486",
            "type": "color"
          },
          "name": "ColorMomentumBoldPressed",
          "attributes": {
            "category": "color",
            "type": "momentum",
            "item": "bold",
            "subitem": "pressed"
          },
          "path": [
            "color",
            "momentum",
            "bold",
            "pressed"
          ]
        },
        "disabled": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d24d",
            "type": "color"
          },
          "name": "ColorMomentumBoldDisabled",
          "attributes": {
            "category": "color",
            "type": "momentum",
            "item": "bold",
            "subitem": "disabled"
          },
          "path": [
            "color",
            "momentum",
            "bold",
            "disabled"
          ]
        },
        "accessible": {
          "value": "#1e39d2",
          "type": "color",
          "description": "Closest shade of default color that exceeds a 4.5:1 contrast ratio against the page color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d2",
            "type": "color",
            "description": "Closest shade of default color that exceeds a 4.5:1 contrast ratio against the page color"
          },
          "name": "ColorMomentumBoldAccessible",
          "attributes": {
            "category": "color",
            "type": "momentum",
            "item": "bold",
            "subitem": "accessible"
          },
          "path": [
            "color",
            "momentum",
            "bold",
            "accessible"
          ]
        }
      },
      "subtle": {
        "default": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d214",
            "type": "color"
          },
          "name": "ColorMomentumSubtleDefault",
          "attributes": {
            "category": "color",
            "type": "momentum",
            "item": "subtle",
            "subitem": "default"
          },
          "path": [
            "color",
            "momentum",
            "subtle",
            "default"
          ]
        },
        "hover": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d226",
            "type": "color"
          },
          "name": "ColorMomentumSubtleHover",
          "attributes": {
            "category": "color",
            "type": "momentum",
            "item": "subtle",
            "subitem": "hover"
          },
          "path": [
            "color",
            "momentum",
            "subtle",
            "hover"
          ]
        },
        "pressed": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d238",
            "type": "color"
          },
          "name": "ColorMomentumSubtlePressed",
          "attributes": {
            "category": "color",
            "type": "momentum",
            "item": "subtle",
            "subitem": "pressed"
          },
          "path": [
            "color",
            "momentum",
            "subtle",
            "pressed"
          ]
        }
      }
    },
    "partnership": {
      "bold": {
        "default": {
          "value": "#fa3c00",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#fa3c00",
            "type": "color"
          },
          "name": "ColorPartnershipBoldDefault",
          "attributes": {
            "category": "color",
            "type": "partnership",
            "item": "bold",
            "subitem": "default"
          },
          "path": [
            "color",
            "partnership",
            "bold",
            "default"
          ]
        },
        "hover": {
          "value": "#c83000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#c83000",
            "type": "color"
          },
          "name": "ColorPartnershipBoldHover",
          "attributes": {
            "category": "color",
            "type": "partnership",
            "item": "bold",
            "subitem": "hover"
          },
          "path": [
            "color",
            "partnership",
            "bold",
            "hover"
          ]
        },
        "pressed": {
          "value": "#a02600",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#a02600",
            "type": "color"
          },
          "name": "ColorPartnershipBoldPressed",
          "attributes": {
            "category": "color",
            "type": "partnership",
            "item": "bold",
            "subitem": "pressed"
          },
          "path": [
            "color",
            "partnership",
            "bold",
            "pressed"
          ]
        },
        "disabled": {
          "value": "#fa3c00",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#fa3c005e",
            "type": "color"
          },
          "name": "ColorPartnershipBoldDisabled",
          "attributes": {
            "category": "color",
            "type": "partnership",
            "item": "bold",
            "subitem": "disabled"
          },
          "path": [
            "color",
            "partnership",
            "bold",
            "disabled"
          ]
        },
        "accessible": {
          "value": "#c83000",
          "type": "color",
          "description": "Closest shade of default color that exceeds a 4.5:1 contrast ratio against the page color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#c83000",
            "type": "color",
            "description": "Closest shade of default color that exceeds a 4.5:1 contrast ratio against the page color"
          },
          "name": "ColorPartnershipBoldAccessible",
          "attributes": {
            "category": "color",
            "type": "partnership",
            "item": "bold",
            "subitem": "accessible"
          },
          "path": [
            "color",
            "partnership",
            "bold",
            "accessible"
          ]
        }
      },
      "subtle": {
        "default": {
          "value": "#fa3c00",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#fa3c0017",
            "type": "color"
          },
          "name": "ColorPartnershipSubtleDefault",
          "attributes": {
            "category": "color",
            "type": "partnership",
            "item": "subtle",
            "subitem": "default"
          },
          "path": [
            "color",
            "partnership",
            "subtle",
            "default"
          ]
        },
        "hover": {
          "value": "#fa3c00",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#fa3c0030",
            "type": "color"
          },
          "name": "ColorPartnershipSubtleHover",
          "attributes": {
            "category": "color",
            "type": "partnership",
            "item": "subtle",
            "subitem": "hover"
          },
          "path": [
            "color",
            "partnership",
            "subtle",
            "hover"
          ]
        },
        "pressed": {
          "value": "#fa3c00",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#fa3c004a",
            "type": "color"
          },
          "name": "ColorPartnershipSubtlePressed",
          "attributes": {
            "category": "color",
            "type": "partnership",
            "item": "subtle",
            "subitem": "pressed"
          },
          "path": [
            "color",
            "partnership",
            "subtle",
            "pressed"
          ]
        }
      }
    },
    "feedback": {
      "info": {
        "bold": {
          "value": "#0043ce",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0043ce",
            "type": "color"
          },
          "name": "ColorFeedbackInfoBold",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "info",
            "subitem": "bold"
          },
          "path": [
            "color",
            "feedback",
            "info",
            "bold"
          ]
        },
        "subtle": {
          "value": "#0043ce",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0043ce14",
            "type": "color"
          },
          "name": "ColorFeedbackInfoSubtle",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "info",
            "subitem": "subtle"
          },
          "path": [
            "color",
            "feedback",
            "info",
            "subtle"
          ]
        },
        "accessible": {
          "value": "#0043ce",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0043ce",
            "type": "color"
          },
          "name": "ColorFeedbackInfoAccessible",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "info",
            "subitem": "accessible"
          },
          "path": [
            "color",
            "feedback",
            "info",
            "accessible"
          ]
        }
      },
      "success": {
        "bold": {
          "value": "#198038",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#198038",
            "type": "color"
          },
          "name": "ColorFeedbackSuccessBold",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "success",
            "subitem": "bold"
          },
          "path": [
            "color",
            "feedback",
            "success",
            "bold"
          ]
        },
        "subtle": {
          "value": "#198038",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1980381a",
            "type": "color"
          },
          "name": "ColorFeedbackSuccessSubtle",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "success",
            "subitem": "subtle"
          },
          "path": [
            "color",
            "feedback",
            "success",
            "subtle"
          ]
        },
        "accessible": {
          "value": "#187d37",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#187d37",
            "type": "color"
          },
          "name": "ColorFeedbackSuccessAccessible",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "success",
            "subitem": "accessible"
          },
          "path": [
            "color",
            "feedback",
            "success",
            "accessible"
          ]
        }
      },
      "warning": {
        "bold": {
          "value": "#f1c21b",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#f1c21b",
            "type": "color"
          },
          "name": "ColorFeedbackWarningBold",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "warning",
            "subitem": "bold"
          },
          "path": [
            "color",
            "feedback",
            "warning",
            "bold"
          ]
        },
        "subtle": {
          "value": "#f1c21b",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#f1c21b1f",
            "type": "color"
          },
          "name": "ColorFeedbackWarningSubtle",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "warning",
            "subitem": "subtle"
          },
          "path": [
            "color",
            "feedback",
            "warning",
            "subtle"
          ]
        },
        "accessible": {
          "value": "#a16b00",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#a16b00",
            "type": "color"
          },
          "name": "ColorFeedbackWarningAccessible",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "warning",
            "subitem": "accessible"
          },
          "path": [
            "color",
            "feedback",
            "warning",
            "accessible"
          ]
        }
      },
      "danger": {
        "bold": {
          "value": "#da1e28",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#da1e28",
            "type": "color"
          },
          "name": "ColorFeedbackDangerBold",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "danger",
            "subitem": "bold"
          },
          "path": [
            "color",
            "feedback",
            "danger",
            "bold"
          ]
        },
        "subtle": {
          "value": "#da1e28",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#da1e2814",
            "type": "color"
          },
          "name": "ColorFeedbackDangerSubtle",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "danger",
            "subitem": "subtle"
          },
          "path": [
            "color",
            "feedback",
            "danger",
            "subtle"
          ]
        },
        "accessible": {
          "value": "#cc1c25",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#cc1c25",
            "type": "color"
          },
          "name": "ColorFeedbackDangerAccessible",
          "attributes": {
            "category": "color",
            "type": "feedback",
            "item": "danger",
            "subitem": "accessible"
          },
          "path": [
            "color",
            "feedback",
            "danger",
            "accessible"
          ]
        }
      }
    },
    "activity": {
      "current": {
        "bold": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d2",
            "type": "color"
          },
          "name": "ColorActivityCurrentBold",
          "attributes": {
            "category": "color",
            "type": "activity",
            "item": "current",
            "subitem": "bold"
          },
          "path": [
            "color",
            "activity",
            "current",
            "bold"
          ]
        },
        "subtle": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d214",
            "type": "color"
          },
          "name": "ColorActivityCurrentSubtle",
          "attributes": {
            "category": "color",
            "type": "activity",
            "item": "current",
            "subitem": "subtle"
          },
          "path": [
            "color",
            "activity",
            "current",
            "subtle"
          ]
        },
        "accessible": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d2",
            "type": "color"
          },
          "name": "ColorActivityCurrentAccessible",
          "attributes": {
            "category": "color",
            "type": "activity",
            "item": "current",
            "subitem": "accessible"
          },
          "path": [
            "color",
            "activity",
            "current",
            "accessible"
          ]
        }
      },
      "focus": {
        "border": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d2",
            "type": "color"
          },
          "name": "ColorActivityFocusBorder",
          "attributes": {
            "category": "color",
            "type": "activity",
            "item": "focus",
            "subitem": "border"
          },
          "path": [
            "color",
            "activity",
            "focus",
            "border"
          ]
        },
        "glow": {
          "value": "#1e39d2",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#1e39d226",
            "type": "color"
          },
          "name": "ColorActivityFocusGlow",
          "attributes": {
            "category": "color",
            "type": "activity",
            "item": "focus",
            "subitem": "glow"
          },
          "path": [
            "color",
            "activity",
            "focus",
            "glow"
          ]
        },
        "glowControl": {
          "value": "#000000",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#0000001c",
            "type": "color"
          },
          "name": "ColorActivityFocusGlowControl",
          "attributes": {
            "category": "color",
            "type": "activity",
            "item": "focus",
            "subitem": "glowControl"
          },
          "path": [
            "color",
            "activity",
            "focus",
            "glowControl"
          ]
        }
      }
    }
  },
  "shadowOutline": {
    "value": "#e3e3e3",
    "filePath": "src/shadows/shadows.js",
    "isSource": true,
    "original": {
      "value": "{color.gray.accent.value}"
    },
    "name": "ShadowOutline",
    "attributes": {
      "category": "shadowOutline"
    },
    "path": [
      "shadowOutline"
    ]
  },
  "shadow": {
    "none": {
      "value": "none",
      "filePath": "src/shadows/shadows.js",
      "isSource": true,
      "original": {
        "value": "none"
      },
      "name": "ShadowNone",
      "attributes": {
        "category": "shadow",
        "type": "none"
      },
      "path": [
        "shadow",
        "none"
      ]
    },
    "xs": {
      "value": "0px 4px 8px rgba(0, 0, 0, 0.08)",
      "filePath": "src/shadows/shadows.js",
      "isSource": true,
      "original": {
        "value": "0px 4px 8px rgba(0, 0, 0, 0.08)"
      },
      "name": "ShadowXs",
      "attributes": {
        "category": "shadow",
        "type": "xs"
      },
      "path": [
        "shadow",
        "xs"
      ]
    },
    "small": {
      "value": "0px 6px 12px rgba(0, 0, 0, 0.11)",
      "filePath": "src/shadows/shadows.js",
      "isSource": true,
      "original": {
        "value": "0px 6px 12px rgba(0, 0, 0, 0.11)"
      },
      "name": "ShadowSmall",
      "attributes": {
        "category": "shadow",
        "type": "small"
      },
      "path": [
        "shadow",
        "small"
      ]
    },
    "medium": {
      "value": "0px 9px 18px rgba(0, 0, 0, 0.15)",
      "filePath": "src/shadows/shadows.js",
      "isSource": true,
      "original": {
        "value": "0px 9px 18px rgba(0, 0, 0, 0.15)"
      },
      "name": "ShadowMedium",
      "attributes": {
        "category": "shadow",
        "type": "medium"
      },
      "path": [
        "shadow",
        "medium"
      ]
    },
    "large": {
      "value": "0px 13px 37px rgba(0, 0, 0, 0.21)",
      "filePath": "src/shadows/shadows.js",
      "isSource": true,
      "original": {
        "value": "0px 13px 37px rgba(0, 0, 0, 0.21)"
      },
      "name": "ShadowLarge",
      "attributes": {
        "category": "shadow",
        "type": "large"
      },
      "path": [
        "shadow",
        "large"
      ]
    },
    "xl": {
      "value": "0px 20px 56px rgba(0, 0, 0, 0.29)",
      "filePath": "src/shadows/shadows.js",
      "isSource": true,
      "original": {
        "value": "0px 20px 56px rgba(0, 0, 0, 0.29)"
      },
      "name": "ShadowXl",
      "attributes": {
        "category": "shadow",
        "type": "xl"
      },
      "path": [
        "shadow",
        "xl"
      ]
    }
  },
  "spacing": {
    "8": {
      "value": "8px",
      "filePath": "src/spacing/spacing.js",
      "isSource": true,
      "original": {
        "value": "8px"
      },
      "name": "Spacing8",
      "attributes": {
        "category": "spacing",
        "type": "8"
      },
      "path": [
        "spacing",
        "8"
      ]
    },
    "16": {
      "value": "16px",
      "filePath": "src/spacing/spacing.js",
      "isSource": true,
      "original": {
        "value": "16px"
      },
      "name": "Spacing16",
      "attributes": {
        "category": "spacing",
        "type": "16"
      },
      "path": [
        "spacing",
        "16"
      ]
    },
    "32": {
      "value": "32px",
      "filePath": "src/spacing/spacing.js",
      "isSource": true,
      "original": {
        "value": "32px"
      },
      "name": "Spacing32",
      "attributes": {
        "category": "spacing",
        "type": "32"
      },
      "path": [
        "spacing",
        "32"
      ]
    },
    "48": {
      "value": "48px",
      "filePath": "src/spacing/spacing.js",
      "isSource": true,
      "original": {
        "value": "48px"
      },
      "name": "Spacing48",
      "attributes": {
        "category": "spacing",
        "type": "48"
      },
      "path": [
        "spacing",
        "48"
      ]
    },
    "56": {
      "value": "56px",
      "filePath": "src/spacing/spacing.js",
      "isSource": true,
      "original": {
        "value": "56px"
      },
      "name": "Spacing56",
      "attributes": {
        "category": "spacing",
        "type": "56"
      },
      "path": [
        "spacing",
        "56"
      ]
    }
  },
  "typography": {
    "family": {
      "value": "Sharp Sans",
      "filePath": "src/typography/typography.js",
      "isSource": true,
      "original": {
        "value": "Sharp Sans"
      },
      "name": "TypographyFamily",
      "attributes": {
        "category": "typography",
        "type": "family"
      },
      "path": [
        "typography",
        "family"
      ]
    },
    "heading": {
      "h1": {
        "size": {
          "value": "64px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "64px"
          },
          "name": "TypographyHeadingH1Size",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h1",
            "subitem": "size"
          },
          "path": [
            "typography",
            "heading",
            "h1",
            "size"
          ]
        },
        "lineHeight": {
          "value": "72px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "72px"
          },
          "name": "TypographyHeadingH1LineHeight",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h1",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "heading",
            "h1",
            "lineHeight"
          ]
        }
      },
      "h2": {
        "size": {
          "value": "48px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "48px"
          },
          "name": "TypographyHeadingH2Size",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h2",
            "subitem": "size"
          },
          "path": [
            "typography",
            "heading",
            "h2",
            "size"
          ]
        },
        "lineHeight": {
          "value": "56px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "56px"
          },
          "name": "TypographyHeadingH2LineHeight",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h2",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "heading",
            "h2",
            "lineHeight"
          ]
        }
      },
      "h3": {
        "size": {
          "value": "40px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "40px"
          },
          "name": "TypographyHeadingH3Size",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h3",
            "subitem": "size"
          },
          "path": [
            "typography",
            "heading",
            "h3",
            "size"
          ]
        },
        "lineHeight": {
          "value": "48px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "48px"
          },
          "name": "TypographyHeadingH3LineHeight",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h3",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "heading",
            "h3",
            "lineHeight"
          ]
        }
      },
      "h4": {
        "size": {
          "value": "32px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "32px"
          },
          "name": "TypographyHeadingH4Size",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h4",
            "subitem": "size"
          },
          "path": [
            "typography",
            "heading",
            "h4",
            "size"
          ]
        },
        "lineHeight": {
          "value": "40px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "40px"
          },
          "name": "TypographyHeadingH4LineHeight",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h4",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "heading",
            "h4",
            "lineHeight"
          ]
        }
      },
      "h5": {
        "size": {
          "value": "24px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "24px"
          },
          "name": "TypographyHeadingH5Size",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h5",
            "subitem": "size"
          },
          "path": [
            "typography",
            "heading",
            "h5",
            "size"
          ]
        },
        "lineHeight": {
          "value": "32px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "32px"
          },
          "name": "TypographyHeadingH5LineHeight",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h5",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "heading",
            "h5",
            "lineHeight"
          ]
        }
      },
      "h6": {
        "size": {
          "value": "20px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "20px"
          },
          "name": "TypographyHeadingH6Size",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h6",
            "subitem": "size"
          },
          "path": [
            "typography",
            "heading",
            "h6",
            "size"
          ]
        },
        "lineHeight": {
          "value": "28px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "28px"
          },
          "name": "TypographyHeadingH6LineHeight",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "h6",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "heading",
            "h6",
            "lineHeight"
          ]
        }
      },
      "sub": {
        "size": {
          "value": "18px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "18px"
          },
          "name": "TypographyHeadingSubSize",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "sub",
            "subitem": "size"
          },
          "path": [
            "typography",
            "heading",
            "sub",
            "size"
          ]
        },
        "lineHeight": {
          "value": "26px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "26px"
          },
          "name": "TypographyHeadingSubLineHeight",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "sub",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "heading",
            "sub",
            "lineHeight"
          ]
        },
        "fontWeight": {
          "value": "600",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "600"
          },
          "name": "TypographyHeadingSubFontWeight",
          "attributes": {
            "category": "typography",
            "type": "heading",
            "item": "sub",
            "subitem": "fontWeight"
          },
          "path": [
            "typography",
            "heading",
            "sub",
            "fontWeight"
          ]
        }
      }
    },
    "body": {
      "long1": {
        "size": {
          "value": "14px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "14px"
          },
          "name": "TypographyBodyLong1Size",
          "attributes": {
            "category": "typography",
            "type": "body",
            "item": "long1",
            "subitem": "size"
          },
          "path": [
            "typography",
            "body",
            "long1",
            "size"
          ]
        },
        "lineHeight": {
          "value": "20px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "20px"
          },
          "name": "TypographyBodyLong1LineHeight",
          "attributes": {
            "category": "typography",
            "type": "body",
            "item": "long1",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "body",
            "long1",
            "lineHeight"
          ]
        }
      },
      "long2": {
        "size": {
          "value": "16px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "16px"
          },
          "name": "TypographyBodyLong2Size",
          "attributes": {
            "category": "typography",
            "type": "body",
            "item": "long2",
            "subitem": "size"
          },
          "path": [
            "typography",
            "body",
            "long2",
            "size"
          ]
        },
        "lineHeight": {
          "value": "24px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "24px"
          },
          "name": "TypographyBodyLong2LineHeight",
          "attributes": {
            "category": "typography",
            "type": "body",
            "item": "long2",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "body",
            "long2",
            "lineHeight"
          ]
        }
      },
      "short1": {
        "size": {
          "value": "14px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "14px"
          },
          "name": "TypographyBodyShort1Size",
          "attributes": {
            "category": "typography",
            "type": "body",
            "item": "short1",
            "subitem": "size"
          },
          "path": [
            "typography",
            "body",
            "short1",
            "size"
          ]
        },
        "lineHeight": {
          "value": "18px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "18px"
          },
          "name": "TypographyBodyShort1LineHeight",
          "attributes": {
            "category": "typography",
            "type": "body",
            "item": "short1",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "body",
            "short1",
            "lineHeight"
          ]
        }
      },
      "short2": {
        "size": {
          "value": "16px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "16px"
          },
          "name": "TypographyBodyShort2Size",
          "attributes": {
            "category": "typography",
            "type": "body",
            "item": "short2",
            "subitem": "size"
          },
          "path": [
            "typography",
            "body",
            "short2",
            "size"
          ]
        },
        "lineHeight": {
          "value": "22px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "22px"
          },
          "name": "TypographyBodyShort2LineHeight",
          "attributes": {
            "category": "typography",
            "type": "body",
            "item": "short2",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "body",
            "short2",
            "lineHeight"
          ]
        }
      }
    },
    "caption": {
      "captionRegular": {
        "size": {
          "value": "12px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "12px"
          },
          "name": "TypographyCaptionCaptionRegularSize",
          "attributes": {
            "category": "typography",
            "type": "caption",
            "item": "captionRegular",
            "subitem": "size"
          },
          "path": [
            "typography",
            "caption",
            "captionRegular",
            "size"
          ]
        },
        "lineHeight": {
          "value": "16px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "16px"
          },
          "name": "TypographyCaptionCaptionRegularLineHeight",
          "attributes": {
            "category": "typography",
            "type": "caption",
            "item": "captionRegular",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "caption",
            "captionRegular",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0.015em",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "0.015em"
          },
          "name": "TypographyCaptionCaptionRegularLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "caption",
            "item": "captionRegular",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "caption",
            "captionRegular",
            "letterSpacing"
          ]
        }
      },
      "captionSmall": {
        "size": {
          "value": "11px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "11px"
          },
          "name": "TypographyCaptionCaptionSmallSize",
          "attributes": {
            "category": "typography",
            "type": "caption",
            "item": "captionSmall",
            "subitem": "size"
          },
          "path": [
            "typography",
            "caption",
            "captionSmall",
            "size"
          ]
        },
        "lineHeight": {
          "value": "14px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "14px"
          },
          "name": "TypographyCaptionCaptionSmallLineHeight",
          "attributes": {
            "category": "typography",
            "type": "caption",
            "item": "captionSmall",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "caption",
            "captionSmall",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0.015em",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "0.015em"
          },
          "name": "TypographyCaptionCaptionSmallLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "caption",
            "item": "captionSmall",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "caption",
            "captionSmall",
            "letterSpacing"
          ]
        }
      },
      "captionLarge": {
        "size": {
          "value": "13px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "13px"
          },
          "name": "TypographyCaptionCaptionLargeSize",
          "attributes": {
            "category": "typography",
            "type": "caption",
            "item": "captionLarge",
            "subitem": "size"
          },
          "path": [
            "typography",
            "caption",
            "captionLarge",
            "size"
          ]
        },
        "lineHeight": {
          "value": "100%",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "100%"
          },
          "name": "TypographyCaptionCaptionLargeLineHeight",
          "attributes": {
            "category": "typography",
            "type": "caption",
            "item": "captionLarge",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "caption",
            "captionLarge",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0.015em",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "0.015em"
          },
          "name": "TypographyCaptionCaptionLargeLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "caption",
            "item": "captionLarge",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "caption",
            "captionLarge",
            "letterSpacing"
          ]
        }
      }
    },
    "button": {
      "small": {
        "size": {
          "value": "12px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "12px"
          },
          "name": "TypographyButtonSmallSize",
          "attributes": {
            "category": "typography",
            "type": "button",
            "item": "small",
            "subitem": "size"
          },
          "path": [
            "typography",
            "button",
            "small",
            "size"
          ]
        },
        "lineHeight": {
          "value": "16px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "16px"
          },
          "name": "TypographyButtonSmallLineHeight",
          "attributes": {
            "category": "typography",
            "type": "button",
            "item": "small",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "button",
            "small",
            "lineHeight"
          ]
        }
      },
      "medium": {
        "size": {
          "value": "14px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "14px"
          },
          "name": "TypographyButtonMediumSize",
          "attributes": {
            "category": "typography",
            "type": "button",
            "item": "medium",
            "subitem": "size"
          },
          "path": [
            "typography",
            "button",
            "medium",
            "size"
          ]
        },
        "lineHeight": {
          "value": "18px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "18px"
          },
          "name": "TypographyButtonMediumLineHeight",
          "attributes": {
            "category": "typography",
            "type": "button",
            "item": "medium",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "button",
            "medium",
            "lineHeight"
          ]
        }
      },
      "large": {
        "size": {
          "value": "16px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "16px"
          },
          "name": "TypographyButtonLargeSize",
          "attributes": {
            "category": "typography",
            "type": "button",
            "item": "large",
            "subitem": "size"
          },
          "path": [
            "typography",
            "button",
            "large",
            "size"
          ]
        },
        "lineHeight": {
          "value": "22px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "22px"
          },
          "name": "TypographyButtonLargeLineHeight",
          "attributes": {
            "category": "typography",
            "type": "button",
            "item": "large",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "button",
            "large",
            "lineHeight"
          ]
        }
      }
    },
    "icon": {
      "small": {
        "size": {
          "value": "16px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "16px"
          },
          "name": "TypographyIconSmallSize",
          "attributes": {
            "category": "typography",
            "type": "icon",
            "item": "small",
            "subitem": "size"
          },
          "path": [
            "typography",
            "icon",
            "small",
            "size"
          ]
        }
      },
      "medium": {
        "size": {
          "value": "20px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "20px"
          },
          "name": "TypographyIconMediumSize",
          "attributes": {
            "category": "typography",
            "type": "icon",
            "item": "medium",
            "subitem": "size"
          },
          "path": [
            "typography",
            "icon",
            "medium",
            "size"
          ]
        }
      },
      "large": {
        "size": {
          "value": "24px",
          "filePath": "src/typography/typography.js",
          "isSource": true,
          "original": {
            "value": "24px"
          },
          "name": "TypographyIconLargeSize",
          "attributes": {
            "category": "typography",
            "type": "icon",
            "item": "large",
            "subitem": "size"
          },
          "path": [
            "typography",
            "icon",
            "large",
            "size"
          ]
        }
      }
    }
  },
  "form": {
    "color": {
      "text": {
        "input": {
          "value": "#000000db",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#000000db",
            "type": "color"
          },
          "name": "FormColorTextInput",
          "attributes": {
            "category": "form",
            "type": "color",
            "item": "text",
            "subitem": "input"
          },
          "path": [
            "form",
            "color",
            "text",
            "input"
          ]
        },
        "label": {
          "value": "#00000091",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000091",
            "type": "color"
          },
          "name": "FormColorTextLabel",
          "attributes": {
            "category": "form",
            "type": "color",
            "item": "text",
            "subitem": "label"
          },
          "path": [
            "form",
            "color",
            "text",
            "label"
          ]
        },
        "hint": {
          "value": "#00000091",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000091",
            "type": "color"
          },
          "name": "FormColorTextHint",
          "attributes": {
            "category": "form",
            "type": "color",
            "item": "text",
            "subitem": "hint"
          },
          "path": [
            "form",
            "color",
            "text",
            "hint"
          ]
        },
        "placeholder": {
          "value": "#00000047",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000047",
            "type": "color"
          },
          "name": "FormColorTextPlaceholder",
          "attributes": {
            "category": "form",
            "type": "color",
            "item": "text",
            "subitem": "placeholder"
          },
          "path": [
            "form",
            "color",
            "text",
            "placeholder"
          ]
        },
        "required": {
          "value": "#da1e28",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#da1e28",
            "type": "color"
          },
          "name": "FormColorTextRequired",
          "attributes": {
            "category": "form",
            "type": "color",
            "item": "text",
            "subitem": "required"
          },
          "path": [
            "form",
            "color",
            "text",
            "required"
          ]
        }
      },
      "border": {
        "default": {
          "value": "#00000069",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000069",
            "type": "color"
          },
          "name": "FormColorBorderDefault",
          "attributes": {
            "category": "form",
            "type": "color",
            "item": "border",
            "subitem": "default"
          },
          "path": [
            "form",
            "color",
            "border",
            "default"
          ]
        }
      },
      "icon": {
        "default": {
          "value": "#00000091",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000091",
            "type": "color"
          },
          "name": "FormColorIconDefault",
          "attributes": {
            "category": "form",
            "type": "color",
            "item": "icon",
            "subitem": "default"
          },
          "path": [
            "form",
            "color",
            "icon",
            "default"
          ]
        },
        "search": {
          "value": "#00000091",
          "type": "color",
          "filePath": "src/tokenTransformerOutput.tmp.json",
          "isSource": true,
          "original": {
            "value": "#00000091",
            "type": "color"
          },
          "name": "FormColorIconSearch",
          "attributes": {
            "category": "form",
            "type": "color",
            "item": "icon",
            "subitem": "search"
          },
          "path": [
            "form",
            "color",
            "icon",
            "search"
          ]
        }
      }
    }
  }
};